import type { Project } from "@/mocks/projects";

interface ProjectInfoProps {
  project: Project;
}

const infoItems = (project: Project) => [
  { icon: "ri-calendar-line", label: "Yıl", value: project.year ?? "—" },
  { icon: "ri-building-2-line", label: "İşveren", value: project.client ?? "—" },
];

export default function ProjectInfo({ project }: ProjectInfoProps) {
  return (
    <section className="bg-white py-16 px-6">
      <div className="max-w-5xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
          {/* Description */}
          <div className="lg:col-span-2">
            <span className="text-[#4CAF50] text-xs font-semibold uppercase tracking-widest mb-3 block">
              Proje Hakkında
            </span>
            <h2 className="text-2xl md:text-3xl font-bold text-[#1A2B4A] mb-5 leading-snug">
              Proje Detayları
            </h2>
            <p className="text-[#4A5568] text-base leading-relaxed mb-8">
              {project.description}
            </p>

            {/* Scope */}
            {project.scope && project.scope.length > 0 && (
              <div>
                <h3 className="text-[#1A2B4A] font-semibold text-base mb-4">
                  Proje Kapsamı
                </h3>
                <div className="flex flex-wrap gap-2">
                  {project.scope.map((item) => (
                    <span
                      key={item}
                      className="flex items-center gap-1.5 text-sm text-[#1A2B4A] bg-[#F8F9FA] border border-[#E2E8F0] px-4 py-2 rounded-full font-medium"
                    >
                      <i className="ri-checkbox-circle-line text-[#4CAF50] text-base" />
                      {item}
                    </span>
                  ))}
                </div>
              </div>
            )}
          </div>

          {/* Info Card */}
          <div className="lg:col-span-1">
            <div className="bg-[#F8F9FA] rounded-2xl p-6 border border-[#E2E8F0]">
              <h3 className="text-[#1A2B4A] font-bold text-base mb-5">
                Proje Bilgileri
              </h3>
              <div className="flex flex-col gap-4">
                {infoItems(project).map((item) => (
                  <div key={item.label} className="flex items-center gap-3">
                    <div className="w-9 h-9 flex items-center justify-center rounded-xl bg-[#4CAF50]/10 flex-shrink-0">
                      <i className={`${item.icon} text-[#4CAF50] text-base`} />
                    </div>
                    <div>
                      <div className="text-xs text-[#718096] font-medium">{item.label}</div>
                      <div className="text-sm text-[#1A2B4A] font-semibold">{item.value}</div>
                    </div>
                  </div>
                ))}
              </div>

              {/* CTA */}
              <div className="mt-6 pt-5 border-t border-[#E2E8F0]">
                <p className="text-xs text-[#718096] mb-3">
                  Benzer bir proje için teklif almak ister misiniz?
                </p>
                <a
                  href="https://wa.me/905321367981"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center gap-2 bg-[#25D366] text-white text-sm font-semibold px-5 py-2.5 rounded-full hover:bg-[#1ebe5d] transition-colors duration-200 cursor-pointer whitespace-nowrap w-full"
                >
                  <i className="ri-whatsapp-line text-base" />
                  WhatsApp ile İletişim
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
